import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import React from 'react';

export const SvgAlignLeft = () => (
  <AlignTextLeftIcon label="" testId="ads-refreshed-icon" />
);
